import React from 'react';
import './quantityTracker.scss';

interface ErrorMessageProps {
  errorMessage?: string,
}

export const ErrorMessage = ({errorMessage = ""}: ErrorMessageProps) => {
  return (
    <div className="ter-quantity-tracker__error-message">
      <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.667969 13H15.3346L8.0013 0.333374L0.667969 13ZM8.66797 11H7.33463V9.66671H8.66797V11ZM8.66797 8.33337H7.33463V5.66671H8.66797V8.33337Z" fill="#AC151D"/>
      </svg>
      {errorMessage}
    </div>
  )
};

export default ErrorMessage
